import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';
import { PaymentService } from '../core/services/payment.service';
import { EncryptionService } from '../core/services/encryption.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
@Component({
  selector: 'app-payment-test',
  templateUrl: './payment-test.component.html',
  styleUrls: ['./payment-test.component.css'],
})
export class PaymentTestComponent implements OnInit {
  encryptedData: any;
  decryptedData: any;
  eKey: any;
  plans = [
    { name: 'Basic', amount: 10, priceId: 'price_YourBasicPlanPriceId', paymentLink: 'https://buy.stripe.com/test_3cI8wI5oW7Xs2wv0Lp8Vi00' },
    { name: 'Premium', amount: 20, priceId: 'price_YourPremiumPlanPriceId', paymentLink: 'https://buy.stripe.com/test_aFa9AMaJga5A8UT3XB8Vi01' },
  ];
  error: string | null = null;

  constructor(private encryptionService: EncryptionService,
    private http: HttpClient, private route: ActivatedRoute,
    private paymentService: PaymentService, private router: Router,
    private authService: AuthService, private afAuth: AngularFireAuth,) { }

  redirectToPayment(paymentLink: string) {
    window.location.href = paymentLink;
  }

  async ngOnInit(): Promise<void> {
    this.authService.getUserData().then(userData => {
      // console.log('test user data', userData); //__CONSOLE_LOG__
    });

    this.route.queryParams.subscribe(async params => {
      const token = params['token'];
      if (token) {

        // try {
        //     this.afAuth.signInWithCustomToken(token)
        //   .then(userCredential => {
        //     console.log('✅ Signed in:', userCredential.user);
        //   this.encryptedData = this.encryptionService.encryptData(JSON.stringify(userCredential.user));
        //   localStorage.setItem('user', this.encryptedData);
        //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        //   setTimeout(() => {
        //     this.router.navigate(['/pricing']);
        //   }, 1000);
        //   })
        //   .catch(error => {
        //     console.error('❌ Sign-in failed:', error);
        //     this.router.navigate(['/login']);
        //   });
        //   // const userCredential = await signInWithCustomToken(this.auth, token);
        //   // console.log('Signed in as:', userCredential.user);
        //   // this.encryptedData = this.encryptionService.encryptData(JSON.stringify(userCredential.user));
        //   // localStorage.setItem('user', this.encryptedData);
        //   // this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        //   // setTimeout(() => {
        //   //   this.router.navigate(['/pricing']);
        //   // }, 1000);

        // } catch (err) {
        //   console.error('Token sign-in failed:', err);
        //   this.router.navigate(['/login']);
        // }
        (await this.paymentService.verifyToken(token)).subscribe(custToken => {
          if (custToken) {
            // console.log('Token login successful', custToken); //__CONSOLE_LOG__
            this.afAuth.signInWithCustomToken(custToken.toString())
              .then(userCredential => {
                // console.log('✅ Signed in:', userCredential.user); //__CONSOLE_LOG__
                this.encryptedData = this.encryptionService.encryptData(JSON.stringify(userCredential.user));
                localStorage.setItem('user', this.encryptedData);
                this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
                setTimeout(() => {
                  this.router.navigate(['/pricing']);
                }, 1000);
              })
            // this.encryptedData = this.encryptionService.encryptData(JSON.stringify(user));
            // localStorage.setItem('user', this.encryptedData);
            // this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
            // setTimeout(() => {
            //   this.router.navigate(['/pricing']);
            // }, 1000);

          } else {
            // console.warn('Token login failed'); //__CONSOLE_LOG__
          }
        });
      }
    });
  }
}